import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import Modal from 'components/Modal';
import PeoplePicker from 'components/PeoplePicker';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import {assignPowerUp} from 'state/stack/stack/stackActions';
import {analyticsTrack} from 'utilities/analytics';
import {ADOBE_ANALYTICS_EVENTS} from 'app/Analytics';
import './AssignPowerUpModal.css';

class AssignPowerUpModal extends React.Component {
  state = {
    userId: null,
  };

  handleUserIdsChange = ([userId]) => {
    this.setState({userId});
  };

  handleSendClick = () => {
    if (!this.state.userId) return;
    this.props.assignPowerUp(this.props.pageId, this.state.userId);
    analyticsTrack(ADOBE_ANALYTICS_EVENTS.BIB__POWER_ASSIGN_SENT);
    this.props.onRequestClose();
  };

  handleCancel = () => {
    analyticsTrack(ADOBE_ANALYTICS_EVENTS.BIB__POWER_NOT_NOW);
    this.props.onRequestClose();
  };

  render() {
    const {isOpen, pageId} = this.props;
    if (!isOpen || !pageId) return null;

    return (
      <Modal isOpen={this.props.isOpen}>
        <div className="AssignPowerUpModal__Header">
          <div className="AssignPowerUpModal__Action">
            <a onClick={this.handleCancel}>
              <FormattedMessage
                id="AssignPowerUpModal__Cancel"
                description="Cancel assigning a user to power up a page"
                defaultMessage="Cancel"
              />
            </a>
          </div>
          <div className="AssignPowerUpModal__Title">
            <FormattedMessage
              id="AssignPowerUpModal__Title"
              description="Title of modal to power up a page"
              defaultMessage="Select person"
            />
          </div>
          <div
            className={cx('AssignPowerUpModal__Action', {
              'AssignPowerUpModal__Action--disabled': !this.state.userId,
            })}
          >
            <a onClick={this.handleSendClick}>
              <FormattedMessage
                id="AssignPowerUpModal__Send"
                description="Send power up request to selected assignees"
                defaultMessage="Assign"
              />
            </a>
          </div>
        </div>
        <div className="AssignPowerUpModal__Instructions">
          <FormattedMessage
            id="AssignPowerUpModal__Instructions"
            description="Instructions for how to assign powering up of a page"
            defaultMessage="This view is running on example data. Keep it real and get your own data in there. Head over to desktop web to connect it yourself or assign someone else to do it."
          />
        </div>
        <PeoplePicker
          onUserIdsChange={this.handleUserIdsChange}
          allowMultiple={false}
        />
      </Modal>
    );
  }
}

AssignPowerUpModal.propTypes = {
  pageId: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

export default connect(
  null,
  {
    assignPowerUp,
  }
)(AssignPowerUpModal);
